module.exports = __webpack_public_path__ + "static/media/ico-professional.e54df6ad.svg";